module.exports = __webpack_public_path__ + "img/mySignatureEle.e8bc86ff.svg";